

function getCookies() {
  return document.cookie.split("; ").reduce((acc, cookie) => {
    const [key, value] = cookie.split("=");
    acc[key] = decodeURIComponent(value);
    return acc;
  }, {});
}

const cookies = getCookies();
let API_BASE_URL;
const hostName= window.location.origin;
API_BASE_URL = hostName+"/api";



  
      // Import the functions you need from the SDKs you need
      import { initializeApp } from "https://www.gstatic.com/firebasejs/10.10.0/firebase-app.js";
      import { getAnalytics } from "https://www.gstatic.com/firebasejs/10.10.0/firebase-analytics.js";
      // TODO: Add SDKs for Firebase products that you want to use
      // https://firebase.google.com/docs/web/setup#available-libraries
      let user_token_cookie = cookies["token"];
      const headers = {
  Authorization: `Bearer ${user_token_cookie}`,
  "Content-Type": "application/json",
};

    let firebaseconfigfromenv="";
      fetch(`${API_BASE_URL}/resume/get_firebase_info`, {
  method: 'POST',
  headers: headers,
})
          .then(response => response.json())
          .then(data => {
             
              
              const firebaseConfig = data;
             
                    // Initialize Firebase
      const app = initializeApp(firebaseConfig);
      const analytics = getAnalytics(app);
              
          })
          .catch(error => console.error("Error fetching API:", error));
      // Your web app's Firebase configuration
      // For Firebase JS SDK v7.20.0 and later, measurementId is optional
     
    